export const isBoolean = (arg: unknown) => typeof arg === 'boolean';

export const isString = (val: unknown) => typeof val === 'string';

export const isNumber = (arg: unknown) => typeof arg === 'number' && Number.isFinite(arg);

export const isEmpty = (string: string) => !!string.trim();

/* eslint-disable */
export const uuidv4 = () => {
  // @ts-ignore
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
};
/* eslint-enable */

export const getCSSPropertyValue = (variableName: string) => {
  return getComputedStyle(document.documentElement).getPropertyValue(variableName);
}
